import PropTypes from 'prop-types';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterRow from '@/src/Search/components/FilterRow';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

const AVAILABILITY_OPTIONS = [
  {value: 'free', label: 'search.availabilityFree'},
  {value: 'subscription', label: 'search.availabilitySubscription'},
];

const AvailabilityFilters = ({query, onChangeHandler}) => {
  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.availability'} />
        </Text>
      }
    >
      {AVAILABILITY_OPTIONS.map(({value, label}) => (
        <FilterRow key={value}>
          <CheckboxCommon
            id={value}
            name={value}
            label={<TextLocal id={label} />}
            data-filter-name={SEARCH_FILTERS.AVAILABILITY}
            data-value={value}
            checked={
              !!query[SEARCH_FILTERS.AVAILABILITY] &&
              // @ts-ignore
              JSON.parse([query[SEARCH_FILTERS.AVAILABILITY]]).includes(value)
            }
            onChange={onChangeHandler}
            isSemibold
          />
        </FilterRow>
      ))}
    </SimpleCollapse>
  );
};

AvailabilityFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default AvailabilityFilters;
